<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actionButtons="[]"
    :title="$t('menu.dataAnalysis')"
    :onFetchData="onFetchData"
    ref="sourcePage"
    resource="product_design_analyses"
  >
    <template v-slot:action>
      <el-button type="primary" @click="() => exportClick(selection)">导出</el-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { columnsExtend, filterColumnsExtend } from '../admin_grapes/product_designs.js';

@Component
export default class ProductDesignCompanyAnalyses extends Vue {
  @Prop(String) type;

  async onFetchData() {
    const data = await this.$request.get('product_designs/company_analyses', { params: { ...this.$route.query } });
    return {
      data
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        prop: 'date_range',
        label: '时间范围',
        renderCell: {
          component: 'el-date-picker',
          props: {
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              shortcuts: [
                {
                  text: '今天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '昨天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24);
                    end.setTime(end.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近7天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近15天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近30天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      'pattern_factory_eq',
      'company_id_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns() {
    const sharedColumns = [
      { prop: 'count', label: '总数量' },
      { prop: 'in_advance_count', label: '提前数量' },
      { prop: 'in_advance_rate', label: '提前率', formatter: (row) => `${(row.in_advance_rate * 100).toFixed(2)}%` },
      { prop: 'on_time_count', label: '准时数量' },
      { prop: 'on_time_rate', label: '准时率', formatter: (row) => `${(row.on_time_rate * 100).toFixed(2)}%` },
      { prop: 'overdue_count', label: '逾期数量' },
      { prop: 'overdue_rate', label: '逾期率', formatter: (row) => `${(row.overdue_rate * 100).toFixed(2)}%` },
      { prop: 'second_overdue_count', label: '二次逾期数量' },
      { prop: 'second_overdue_rate', label: '二次逾期率', formatter: (row) => `${(row.second_overdue_rate * 100).toFixed(2)}%` },
      { prop: 'total_overdue_count', label: '逾期次数' }
    ]

    const array = [
      {
        prop: 'company_name',
        label: '供应商',
      },
      {
        prop: 'product_designs',
        label: '明细',
        type: 'expand',
        width: 80,
        renderCell: (h, { props: { value } }) => {
          const columns = columnsExtend([
            {
              prop: 'date',
              label: '时间',
              width: 100
            },
            'pattern_factory',
            ...sharedColumns
          ].filter(Boolean))

          return <bean-table style={{ width: '100%' }} value={value} columns={columns} height={null} actions={[]} />;
        }
      },
      ...sharedColumns
    ].filter(Boolean)

    return columnsExtend(array);
  }


  async exportClick() {
    await this.$request.get('/product_designs/export_company_analyses', { ...this.$route.query });
    this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
  }
}

export const route = [
  {
    path: '/product_design_company_analyses',
    name: 'product_design_company_analyses.index',
    component: ProductDesignCompanyAnalyses,
    props: {
      type: 'index',
    }
  },
]
</script>
